// Relative path: src/components/Recommendations/GalleryRow.js
import React, { useState } from 'react';
import GalleryPopup from '../Popup/GalleryPopup';
import ReactDOM from 'react-dom';

const GalleryRow = ({ 
  imageUrl = '',
  galleryImages = [],
  optionTitle = 'Option Title',
}) => {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [initialImageIndex, setInitialImageIndex] = useState(0);
  
  // If no gallery images, use a placeholder image
  if (!galleryImages || galleryImages.length === 0) {
    galleryImages = [{ downloadURL: imageUrl || 'https://placehold.co/600x400?text=No+Image' }];
  }
  
  // Ensure we have at least 5 images for the collage (duplicate if needed)
  const collageImages = [...galleryImages];
  while (collageImages.length < 5) {
    collageImages.push(collageImages[collageImages.length % galleryImages.length]);
  }
  
  // Handle image click to open gallery popup
  const handleImageClick = (index) => {
    setInitialImageIndex(index);
    setIsGalleryOpen(true);
  };
  
  // Create a portal for the gallery popup
  const renderGalleryPopup = () => {
    if (!isGalleryOpen) return null;
    
    if (typeof document !== 'undefined') {
      return ReactDOM.createPortal(
        <GalleryPopup 
          isOpen={isGalleryOpen}
          onClose={() => setIsGalleryOpen(false)}
          images={galleryImages}
          initialIndex={initialImageIndex}
        />,
        document.body
      );
    }
    
    return null;
  };
  
  return (
    <div className="w-full h-96 mb-4">
      <div className="flex h-full w-full gap-1">
        {/* Left side - One large image */}
        <div 
          className="flex-1 h-full cursor-pointer overflow-hidden rounded-l-lg relative shadow-lg shadow-gray-300"
          onClick={() => handleImageClick(0)}
        >
          <img 
            src={collageImages[0].downloadURL} 
            alt={`${optionTitle} - Main view`} 
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
          />
          
          {/* Photo count indicator */}
          {galleryImages.length > 5 && (
            <div className="absolute bottom-3 right-3 bg-black bg-opacity-60 text-white text-xs rounded-full px-2 py-1 flex items-center">
              <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <span>+{galleryImages.length} more</span>
            </div>
          )}
        </div>
        
        {/* Right side - 2x2 grid */}
        <div className="w-1/2 h-full grid grid-cols-2 grid-rows-2 gap-1">
          {collageImages.slice(1, 5).map((image, index) => (
            <div 
              key={`gallery-image-${index + 1}`}
              className={`cursor-pointer overflow-hidden shadow-lg shadow-gray-300 ${
                // Explicit corner rounding classes
                index === 1 ? 'rounded-tr-lg' : 
                index === 3 ? 'rounded-br-lg' : ''
              }`}
              onClick={() => handleImageClick(index + 1)}
            >
              <img 
                src={image.downloadURL} 
                alt={`${optionTitle} - View ${index + 2}`}
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
          ))}
        </div>
      </div>
      
      {/* Gallery Popup */}
      {renderGalleryPopup()}
    </div>
  );
};

export default GalleryRow;